import { useEffect, useState } from 'react'
import { useStoreState } from '../store'
import { admin } from '../api'

export default function useTwoFactorResetPermission() {
	const appType = useStoreState(state => state.appModel.app_type)
	const token = useStoreState(state => state.mainAdminModel.admin?.token)
	const [result, setResult] = useState(null)
	useEffect(() => {
		let active = true
		setResult(null)
		if (appType === 'main-admin' && token) {
			admin.getTwoFactorPermissions()
				.then(response => {
					if (active) setResult({ token, allowed: response.data?.canResetTwoFactor === true })
				})
				.catch(() => { if (active) setResult({ token, allowed: false }) })
		}
		return () => { active = false }
	}, [appType, token])
	const ready = appType === 'main-admin' && token && result?.token === token
	return { allowed: Boolean(ready && result.allowed), loading: Boolean(token && !ready) }
}
